import { Reveal } from "../components/Reveal";

const Collective = () => {
  return (
    <section
      id="collective"
      data-testid="collective-section"
      className="relative scroll-mt-24 overflow-hidden bg-noir px-6 py-32 text-noir-text sm:px-10 sm:py-44"
    >
      <div className="mx-auto grid max-w-[1600px] grid-cols-1 gap-16 lg:grid-cols-12 lg:items-center lg:gap-20">
        <div className="lg:col-span-5">
          <Reveal y={40}>
            <div className="overflow-hidden">
              <img
                src="/images/sunmoon-08.jpg"
                alt="We Cook Art — collective"
                className="h-full w-full object-cover transition-transform duration-[1600ms] ease-out hover:scale-[1.04]"
              />
            </div>
          </Reveal>
        </div>

        <div className="lg:col-span-7 lg:pl-6">
          <Reveal>
            <span className="text-[0.7rem] uppercase tracking-[0.28em] text-gold">
              003 — The Collective
            </span>
          </Reveal>
          <Reveal delay={0.05}>
            <h2 className="mt-7 font-serif text-6xl font-light leading-[0.9] tracking-tight text-ivory sm:text-7xl lg:text-8xl">
              We Cook <span className="italic text-gold">Art</span>
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="mt-6 font-serif text-xl italic text-noir-text/70">
              A kitchen for illegal ideas.
            </p>
          </Reveal>

          <div className="mt-10 max-w-2xl space-y-6 text-base leading-relaxed text-noir-text/80">
            <Reveal delay={0.14}>
              <p>
                An independent artist collective built around experimentation, collaboration and
                visual storytelling. A space where photographers, stylists, models, filmmakers and
                artists come together to develop ideas that exist beyond commercial expectations.
              </p>
            </Reveal>
            <Reveal delay={0.2}>
              <p>
                Created from a love for making, it functions as both a creative playground and a
                platform for artistic exploration — the dishes brand managers would never approve,
                plated anyway.
              </p>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Collective;
